"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramCarousel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _components = require("./components");
var styles = _interopRequireWildcard(require("./ProgramCarousel.css"));
var _VerticalScrollable = require("../VerticalScrollable");
var _uiKit = require("@cian/ui-kit");
var _ContentContainer = require("../ContentContainer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgramCarousel = _ref => {
  let {
    items,
    showEscrow,
    onProgramSelect
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  const isPhone = deviceType === 'phone';
  const carousel = /*#__PURE__*/React.createElement(_VerticalScrollable.VerticalScrollable, {
    className: styles['carousel'],
    dataName: "MortgageProgramCarousel",
    withScrollPadding: isPhone
  }, items.map(item => /*#__PURE__*/React.createElement(_components.ProgramItem, (0, _extends2.default)({
    key: item.id
  }, item, {
    showEscrow: showEscrow,
    onClick: () => onProgramSelect(item)
  }))));
  return isPhone ? carousel : /*#__PURE__*/React.createElement(_ContentContainer.ContentContainer, null, carousel);
};
exports.ProgramCarousel = ProgramCarousel;